class AjaxTransport {
    queue = [];
    url;
    period;
    constructor(settings) {
        this.url = settings.url;
        this.period = settings.period;
        this.runPereodicSendingQueue();
    }
    send(sample) {
        this.queue.push({
            name: sample.key,
            type: sample.type,
            value: sample.value,
        });
    }
    runPereodicSendingQueue() {
        setInterval(this.sendSamples, this.period);
    }
    sendSamples = async () => {
        if (!this.queue.length) {
            return;
        }
        try {
            const body = JSON.stringify(this.queue);
            this.queue = [];
            await fetch(this.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
        }
        catch (error) {
            console.error('Failed to send telemetry samples');
        }
    };
}

export { AjaxTransport };
//# sourceMappingURL=ajaxTransport.mjs.map
